module.exports = __webpack_public_path__ + "static/media/fortelling.693926ea.m4a";